import type { JSX } from 'react';

import styles from './ColorSwatchField.module.scss';

interface Props {
  label: string;
  value: string;
  onChange: (hex: string) => void;
  fallback?: string;
}

function normalizeHex(value: string, fallback: string): string {
  return /^#[0-9A-Fa-f]{6}$/.test(value) ? value : fallback;
}

export function ColorSwatchField({
  label,
  value,
  onChange,
  fallback = '#888888',
}: Props): JSX.Element {
  const swatch = normalizeHex(value, fallback);

  return (
    <label className={styles.field}>
      <span className={styles.label}>{label}</span>
      <div className={styles.row}>
        <span className={styles.swatchWrap} style={{ ['--swatch' as string]: swatch }}>
          <span className={styles.swatch} aria-hidden />
          <input
            type="color"
            className={styles.native}
            value={swatch}
            onChange={(e) => onChange(e.target.value.toUpperCase())}
            aria-label={`${label} — selector`}
          />
        </span>
        <input
          type="text"
          className={styles.hex}
          value={value}
          spellCheck={false}
          maxLength={7}
          placeholder={fallback}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
        />
      </div>
    </label>
  );
}
